/**
 * Created by RUSS_ on 16.05.2018
 */
import { apiDelay } from "../utils/developer-utils";

const USER_API_ROOT = "https://alltracker.org/v1/browser";
let lastBrowserAnswer = null;

export function getBrowserInfo() {
  return new Promise((resolve, reject) => {
    // resolve({ data: { country: "RU", language: "ru" } });
    // return;
    if (!lastBrowserAnswer) {
      apiDelay().then(() => {
        $.ajax({
          dataType: "json",
          url: `${USER_API_ROOT}/info`,
          type: "GET",
          crossDomain: true,
          success: function(answer) {
            if (!answer.data.language) {
              // default language en
              answer.data.language = "en";
            }
            if (!answer.data.country) {
              // show always this dialog
              answer.data.country = "DE";
            }
            lastBrowserAnswer = answer;
            resolve(answer);
          },
          error: function(jqXHR, textStatus, errorThrown) {
            resolve({ data: { country: "DE", language: "ru" } });
            // reject(jqXHR);
          }
        });
      });
    } else {
      // we don't need to ask server each time about browser info. One time pro session is enough
      resolve(lastBrowserAnswer);
    }
  });
}



// WEBPACK FOOTER //
// ./src-cookie-manager/api/browser.js